import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptDateModule } from "@common/ux/date/date.module";
import { AdaptEditorViewModule } from "@common/ux/html-editor/editor-view.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { DxDataGridModule, DxDateBoxModule, DxSelectBoxModule } from "devextreme-angular";
import { AdaptOrganisationsSharedModule } from "../organisations/organisations-shared.module";
import { AdaptPeopleSharedModule } from "../people/people-shared.module";
import { AiConversationDetailsDialogComponent } from "./ai-conversation-details-dialog/ai-conversation-details-dialog.component";
import { AiUsageComponent } from "./ai-usage/ai-usage.component";
import { GlobalAiUsagePageComponent, globalAiUsagePageRoute } from "./global-ai-usage-page/global-ai-usage-page.component";

@NgModule({
    declarations: [
        AiUsageComponent,
        GlobalAiUsagePageComponent,
        AiConversationDetailsDialogComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        DxDataGridModule,
        DxDateBoxModule,
        DxSelectBoxModule,
        AdaptDateModule,
        AdaptButtonModule,
        AdaptPeopleSharedModule,
        AdaptOrganisationsSharedModule,
        AdaptCommonDialogModule,
        AdaptEditorViewModule,
        AdaptLoadingSpinnerModule,
    ],
    exports: [
        AiUsageComponent,
    ],
})
export class AdaptAiModule {
    public static readonly Routes = [
        ...globalAiUsagePageRoute.routes,
    ];
}
